import { registerHandler } from "../handler";

declare const pdst: any;

export default function registerHandlers() {
  registerHandler("lead", () => {
    pdst("lead", {
      category: "healthy-weight",
    });
  });

  registerHandler("purchase", ({ order, promoCode }) => {
    pdst("purchase", {
      value: order.eltv_13_months,
      currency: "USD",
      order_id: order.subscriptionId,
      discount_code: promoCode.promoCodeApplied,
    });
  });
}
